<template>
    <div id="top-configuration" :class="{'show': displayTopConfiguration}">
        <div class="top-configuration-content">
            <a
                href="javascript:;"
                class="close-top-configuration show-on-desktop"
                @click="triggerCloseConfiguration()"
            >
                <span class="icon-close"></span>
            </a>

            <router-link style="position: absolute; top: 23px; right: 20%; font-size: 12px; color: #aaa; text-decoration: underline;" to="/3d-viewer" v-if="getEnv === 'test'">
                TEST 3D
            </router-link>

            <router-link style="position: absolute; top: 43px; right: 20%; font-size: 12px; color: #aaa; text-decoration: underline;" to="/qualify-industry/building-and-shelving?init=1" v-if="getEnv === 'test'">
              Qualif industrie
            </router-link>

            <div class="select-brand">
                <div class="select-brand-label">
                    {{ $t("select_a_brand") }}
                </div>
                <template v-if="getEnv === 'test'">
                    <div class="select-brand-list">
                        <a
                            href="javascript:;"
                            v-for="brand in brands"
                            :key="brand"
                            class="brand"
                            :class="{active: brand === selectedBrand}"
                            :data-tracking="`brand__button__${brand}`"
                            @click="selectedBrand = brand"
                        >
                            <span :class="'icon-logo-'+brand" :aria-label="brand"></span>
                        </a>
                    </div>
                </template>
                <template v-else>
                    <div class="select-brand-list">
                        <span
                            v-for="brand in brands"
                            :key="brand"
                            class="brand"
                            :class="{active: brand === selectedBrand}"
                        >
                            <span :class="'icon-logo-'+brand" :aria-label="brand"></span>
                            <span class="coming-soon" v-if="brand !== 'manitou'">Coming soon</span>
                        </span>
                    </div>
                </template>
            </div>

            <div class="columns config-container">
                <div class="column">
                    <div class="select-param">
                        <div class="select-param-label">
                            {{ $t("langage_selection") }}
                        </div>
                        <div class="select-param-select">
                            <b-select v-model="selectedLocale" size="is-large" rounded>
                                <option
                                        v-for="locale in orderedLocales"
                                        :value="locale.code"
                                        :key="locale.code"
                                        v-if="getEnv!=='production' || (getEnv==='production' && !locale.staging)"
                                >{{ locale.label }}</option>
                            </b-select>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="select-param">
                        <div class="select-param-label">
                            {{ $t("country_selection") }}
                        </div>
                        <div class="select-param-select">
                            <b-select v-model="selectedCountry" size="is-large" rounded expanded>
                                <option
                                        v-for="country in orderedCountries"
                                        :value="country.code"
                                        :key="country.code"
                                >{{ country.label }}</option>
                            </b-select>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="select-param">
                        <div class="select-param-label">
                            {{ $t("measure_unit_selection") }}
                        </div>
                        <div class="select-unit-type">
                            <span class="unit-type-label" :class="{'is-faded': selectedUnitType !== 'metric'}">
                                {{ $t('metric') }}
                            </span>
                            <b-switch
                                v-model="selectedUnitType"
                                false-value="metric"
                                true-value="imperial"
                                size="is-large"
                                type="is-brand-fixed no-label"
                            />
                            <span class="unit-type-label" :class="{'is-faded': selectedUnitType !== 'imperial'}">
                                {{ $t('imperial') }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <button
                class="button is-primary is-large is-rounded is-uppercase save-btn"
                :class="brandBackgroundColor"
                @click="save()"
            >
                <span>{{ $t("save_changes") }}</span>
                <span class="icon-save is-medium is-right-side"></span>
            </button>
        </div>
        <proximity-animation
            tag="span"
            class="top-configuration-trigger"
            type="bottom"
            :distance="200"
            :enable="!displayTopConfiguration"
            v-if="displayTrigger"
            :type-params="{default: 43, max: 53, unit: 'px', isNegative: true}"
        >
            <svg class="strip" width="1024px" height="53px" viewBox="0 0 1024 53" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(0.000000, -12.000000)" fill="#101010">
                        <path d="M421.661079,21.8787426 L0,12.3496398 C624.279053,11.8834534 965.945719,11.8834534 1025,12.3496398 L597.947005,21.9107215 C573.692622,22.4537411 550.934109,33.7481286 535.833333,52.7359289 L535.833333,52.7359289 C525.004094,66.3526748 505.186708,68.6123958 491.569962,57.7831569 C489.975019,56.514717 488.50692,55.0945062 487.186304,53.542489 L486.5,52.7359289 C470.278347,33.671881 446.686269,22.4442859 421.661079,21.8787426 Z" id="Languette-etiree"></path>
                    </g>
                </g>
            </svg>
            <span class="trigger-icon" @click="triggerCloseConfiguration()">
                <span class="icon-cogwheel"></span>
            </span>
        </proximity-animation>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { locales } from '@/common/localesList'
    import countries from '@/common/utils/countries_regions.json'

    export default {
        name: 'TopConfiguration',
        props: {
            displayTrigger: {
                type: Boolean,
                required: false,
                default: true
            },
        },
        data() {
            return {
                brands: [
                    // 'mustang',
                    'manitou',
                    'gehl'
                ],
                savedBrand: this.$store.state.settings.brand,
                selectedBrand: this.$store.state.settings.brand,
                savedLocale: this.$store.state.settings.locale,
                selectedLocale: this.$store.state.settings.locale,
                locales: locales,
                savedCountry: this.$store.state.settings.country,
                selectedCountry: this.$store.state.settings.country,
                countries: this.$store.state.settings.countries,
                savedUnitType: this.$store.state.settings.unitType,
                selectedUnitType: this.$store.state.settings.unitType,
                selectionChanged: false
            }
        },
        computed: {
            ...mapState({
                displayTopConfiguration: state => state.settings.displayTopConfiguration,
            }),
            orderedLocales() {
                return this.locales.sort((a, b) => {
                    if(a.label < b.label) { return -1; }
                    if(a.label > b.label) { return 1; }
                    return 0;
                })
            },
            orderedCountries() {
                return this.countries.sort((a, b) => {
                    if(a.label < b.label) { return -1; }
                    if(a.label > b.label) { return 1; }
                    return 0;
                })
            },
        },
        watch: {
            selectedBrand() {
                this.selectionChanged = true;
            },
            selectedLocale() {
                this.selectionChanged = true;
            },
            selectedCountry() {
                this.selectionChanged = true;
            },
            selectedUnitType() {
                this.selectionChanged = true;
            },
        },
        methods: {
            triggerCloseConfiguration() {
                if(this.selectionChanged && this.displayTopConfiguration){
                    this.$buefy.dialog.confirm({
                        title: this.$t('warning'),
                        message: this.$t('all_modifications_will_be_lost'),
                        cancelText: this.$t('cancel'),
                        confirmText: 'OK',
                        type: 'is-warning',
                        onConfirm: () => {
                            this.selectedBrand = this.savedBrand;
                            this.selectedLocale = this.savedLocale;
                            this.selectedCountry = this.savedCountry;
                            this.selectedUnitType = this.savedUnitType;
                            setTimeout(() => this.selectionChanged = false, 200)
                            this.toggleDisplayTopConfiguration()
                        }
                    })
                }
                else {
                    this.toggleDisplayTopConfiguration();
                }
            },
            toggleDisplayTopConfiguration() {
                this.$store.commit('settings/toggleDisplayTopConfiguration')
            },
            async save() {
                this.startLoading()
                if(this.savedBrand !== this.selectedBrand)
                    this.$store.commit('settings/setBrand', this.selectedBrand);
                if(this.savedLocale !== this.selectedLocale) {
                  this.$store.commit('settings/setLocale', this.selectedLocale);
                  await this.$store.dispatch('settings/loadCommonDatas');
                }
                if(this.savedCountry !== this.selectedCountry)
                    await this.$store.dispatch('settings/setCountryAndRelatedRegion', this.selectedCountry);
                if(this.savedUnitType !== this.selectedUnitType)
                    this.$store.commit('settings/setUnitType', this.selectedUnitType);
                this.toggleDisplayTopConfiguration();
              this.$store.commit('searchMachines/reset');
              this.$store.commit('searchAccessories/reset');
              this.$store.commit('searchInnovations/reset');
                if(this.selectionChanged) {
                    this.stopLoading()
                    document.location.reload(true)
                }
            },
        }
    }
</script>

<style lang="scss">
    #top-configuration {
        position: fixed;
        top: -60vh;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 25;
        transition: top 0.5s ease;

        @media #{$mq_phone} {
            top: -100vh;
        }

        &.show {
            top: 0;
            transition: top 0.5s cubic-bezier(1,1.95,.66,.81);
            z-index: 999;

            @media #{$mq_phone} {
                transition: top 0.5s ease;
            }

            .top-configuration-trigger {
                @media #{$mq_phone} {
                    display: none;
                }
            }
        }

        .top-configuration-content {
            background-color: $blackish;
            height: 60vh;
            color: $white;
            padding: 20px;
            overflow: hidden;

            @media #{$mq_phone} {
                height: 100vh;
            }

            &:before {
                content: '';
                position: absolute;
                top: -200px;
                left: 0;
                right: 0;
                height: 200px;
                background-color: $blackish;

                @media #{$mq_phone} {
                    display: none;
                }
            }

            .close-top-configuration {
                display: none;
                position: absolute;
                top: 20px;
                right: 20px;
                color: $white;
                font-size: 18px;

                @media #{$mq_phone} {
                    display: inline-block;
                }

                &.show-on-desktop {
                    display: inline-block;
                }
            }

            .select-brand {
                margin-top: 30px;

                &-label {
                    color: #585858;
                }

                &-list {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 10px;

                    .brand {
                        font-size: 30px;
                        color: #585858;
                        margin: 0 20px;
                        transition: color 0.3s ease;

                        &.active {
                            color: $white;
                        }
                    }

                    .coming-soon {
                        display: block;
                        margin-top: 15px;
                        font-size: 18px;
                    }
                }
            }

            .config-container {
                margin: 30px auto 0 auto;
                max-width: 1280px;

                .select-param {
                    &-label {
                        color: #585858;
                    }

                    &-select {
                        display: inline-block;
                        margin-top: 10px;
                    }

                    .select-unit-type {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        margin-top: 15px;

                        .unit-type-label {
                            text-transform: capitalize;

                            &.is-faded {
                                opacity: 0.3;
                            }
                        }

                        .switch {
                            margin: 0 15px;
                        }
                    }
                }
            }

            .save-btn {
                margin-top: 20px;
            }
        }

        .top-configuration-trigger {
            position: absolute;
            bottom: -43px;
            left: 50%;
            margin-left: -512px;
            display: inline-block;
            cursor: pointer;

            @media #{$mq_phone} {
                display: none;
            }

            .trigger-icon {
                position: absolute;
                top: 10px;
                left: 0;
                right: 0;
                margin: 0 auto;
                width: 100px;
                height: 43px;
                text-align: center;

                .icon-cogwheel {
                    display: inline-block;
                    padding-top: 11px;
                    font-size: 22px;
                    color: $white;
                }
            }
        }
    }
</style>
